import { DELIVERY_TYPES } from './deliveryTypes';
import { IBranch } from 'src/types/branches';
import { WORKING_HOURS_ORDER_TYPE } from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/types/branchEdit';

export const defaultBranch: IBranch = {
  allow_all_payment_methods: 0,
  id: 0,
  external_id: 0,
  is_delete: 0,
  preorder: 1,
  phone: '',
  is_orders: 1,
  min_order_type: 0,
  delivery_fee_type: 0,
  reduced_delivery_fee_type: 0,
  is_max_cash_payment: 0,
  city: { id: 21, name: { en: '' } },
  work_slots: [],
  default_payment_type: 0,
  is_busy: false,
  distance: '',
  name: {
    en: '',
    ar: '',
  },
  is_emenu: false,
  latitude: 22.66058572209651,
  longitude: 48.66347673601963,
  status: 1,
  is_free_delivery: 1,
  delivery_fee: 0,
  payment_type: 2,
  pre_select_default: false,
  delivery_type: DELIVERY_TYPES.PICKUP,
  min_order: 0,
  max_cash_payment: 0,
  is_max_cash_payment_hidden: 0,
  is_curbside: 1,
  is_pickup: true,
  curbside_fee: 0,
  available_payment_types: [],
  payment_types: [{ id: 0, type: 'Cash' }],
  address: 'Riyadh',
  working_hours: '12:00 AM - 11:59 PM',
  working_now: true,
  working_time: [],
  closest_day: {
    id: 0,
    working_day: 'tuesday',
    start_time: '00:00',
    close_time: '23:59',
    menu_group_id: 0,
    menu_group_name: { en: '', ar: '' },
    sort: 0,
    order_type: WORKING_HOURS_ORDER_TYPE.BOTH,
  },
  created_in: '',
  franchise_profile: '',
  branch_profile_name: '',
  branch_profile_id: null,
  reduced: [],
};
